import React from 'react'

import { useFilters } from '../state/FilterProvider'

export const SearchBox: React.FunctionComponent = () => {
  const { searchInput, setSearchInput } = useFilters()
  return (
    <div className="search-box">
      <span className="search-icon">🔍</span>
      <input
        type="text"
        placeholder="Search company, deal, invoice, or sales quote #..."
        value={searchInput}
        onChange={(event) => setSearchInput(event.target.value)}
      />
    </div>
  )
}
